module.exports = __webpack_public_path__ + "f8fa0a8b7b60317f01779158e1e3f2df.jpg";